import { upsertSensorGroupConfig } from '@Actions/sensorGroup.action';
import { UpsertSensorGroupForm } from '@Components';
import { Button, PageWrapper } from '@innovyze/stylovyze';
import { getValue } from '@Selectors';
import { useGlobalization } from '@Translations';
import { MAIN_ROUTES } from '@Types/routes';
import {
	CreateUpdateSensorGroupFormValues,
	SensorGroupFormValues,
} from '@Types/sensorGroup.types';
import { FormikProps } from 'formik';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useNavigateTo from '../../../hooks/useNavigateTo';

export default function CreateSensorGroup() {
	const { t } = useGlobalization();
	const { status } = useSelector(getValue).sensorGroup.upsertSensorGroup;

	const { configuredSensors } =
		useSelector(getValue).sensorGroup.sensorGroupById;

	const formRef = useRef<FormikProps<SensorGroupFormValues>>();
	const [isValid, setIsValid] = React.useState(false);
	const history = useHistory();
	useNavigateTo();
	const dispatch = useDispatch();
	const onSubmit = (values: SensorGroupFormValues) => {
		const formValues: CreateUpdateSensorGroupFormValues = {
			...values,
			sensors: values.sensors?.map(sensor => {
				const selectedSensor = configuredSensors?.find(
					s => s.sensorId == sensor,
				);
				return {
					sensorId: sensor,
					channelType: selectedSensor?.channelType || '',
					resolutions: selectedSensor?.resolutions.split(','),
				};
			}),
			originalSensors: values.originalSensors?.map(sensor => {
				return {
					sensorId: sensor,
					channelType:
						configuredSensors?.find(s => s.sensorId == sensor)
							?.channelType || '',
					resolutions: undefined,
				};
			}),
		};
		dispatch(upsertSensorGroupConfig(formValues));
	};
	return (
		<PageWrapper
			title={t('New sensor group')}
			secondary={
				<>
					<Button
						dataCy="cancelSensorGroup"
						variant="contained"
						color="secondary"
						onClick={() => {
							history.push(MAIN_ROUTES.SensorGroups);
						}}>
						{t('Cancel')}
					</Button>
					<Button
						dataCy="saveSensorGroup"
						style={{ marginLeft: 8 }}
						variant="contained"
						color="primary"
						onClick={() => {
							formRef?.current?.submitForm();
						}}
						disabled={!isValid || status === 'pending'}>
						{t('Save')}
					</Button>
				</>
			}
			applyPadding
			headerUnderline>
			<UpsertSensorGroupForm
				onSubmit={onSubmit}
				formRef={formRef}
				setIsValid={setIsValid}
			/>
		</PageWrapper>
	);
}
